import { css } from 'styled-components';
import token from 'styled-token';
import { focusMixin } from '../focusMixin';
import { listResetMixin } from '../listResetMixin';
export var ListboxMixin = function ListboxMixin(props) {
  var size = props.size;
  return token({
    borderWidth: 'Input.borderWidth',
    borderColor: 'Input.borderColor',
    borderRadius: 'Listbox.borderRadius',
    maxHeight: "Listbox.sizes." + size
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      maxHeight = _ref.maxHeight;
    return css(["border:", "px solid ", ";border-radius:", "px;overflow-y:auto;max-height:", ";box-sizing:border-box;", " ", ""], borderWidth, borderColor, borderRadius, maxHeight ? maxHeight + "px" : '100%', listResetMixin(props), focusMixin(props));
  })(props);
};